import { apiClient } from "@base/api/client";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { type ProjectContractorsResponse, projectContractorsResponseSchema } from "./projectContractorsSchema";

async function fetchProjectContractors(projectId: string, keyword: string): Promise<ProjectContractorsResponse> {
  const trimmed = keyword.trim();
  const response = await apiClient.get<unknown>(`/project-management/api/projects/${projectId}/contractors`, {
    params: trimmed ? { keyword: trimmed } : undefined,
  });
  return projectContractorsResponseSchema.parse(response.data);
}

export function projectContractorsQueryOptions(projectId: string, keyword: string) {
  const trimmed = keyword.trim();
  return {
    queryKey: ["project-contractors", projectId, trimmed] as const,
    queryFn: () => fetchProjectContractors(projectId, keyword),
  };
}

export function useProjectContractorsQuery(
  projectId: string,
  keyword: string,
  options?: Omit<UseQueryOptions<ProjectContractorsResponse>, "queryKey" | "queryFn">,
) {
  return useQuery({
    ...projectContractorsQueryOptions(projectId, keyword),
    ...options,
  });
}
